// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__q1pmW","noInteraction":"EventWrapper_noInteraction__2xlEG","pointerPassthrough":"EventWrapper_pointerPassthrough__1BlI2"};